import React, { useState } from "react";
import "../css/Workout.css";

const Workout = () => {
  const [level, setLevel] = useState("beginner");

  // ---------------- CATEGORY DATA ----------------
  const categories = {
    beginner: [
      { title: "CHEST DAY", desc: "Chest Only (Beginner Focus)" },
      { title: "BACK DAY", desc: "Back Only" },
      { title: "SHOULDERS", desc: "Shoulders Only" },
      { title: "ARMS", desc: "Biceps • Triceps" },
      { title: "LEGS", desc: "Quads • Hams • Glutes" }
    ],

    intermediate: [
      { title: "CHEST + TRICEPS", desc: "One Big + One Small Muscle" },
      { title: "BACK + BICEPS", desc: "Strength + Isolation" },
      { title: "SHOULDERS + ABS", desc: "Upper Body Balance" },
      { title: "LEGS + CALVES", desc: "Heavy Lower Body" },
      { title: "ARMS SUPERSET", desc: "Biceps • Triceps" }
    ],

    advanced: [
      { title: "PUSH DAY", desc: "Chest • Shoulders • Triceps" },
      { title: "PULL DAY", desc: "Back • Rear Delts • Biceps" },
      { title: "LEG DAY", desc: "Quads • Hams • Glutes" },
      { title: "CORE", desc: "Abs • Obliques • Stability" },
      { title: "FULL BODY", desc: "Strength • Conditioning" }
    ]
  };

  return (
    <div className="workout-page">

      {/* ---------------- HERO ---------------- */}
      <section className="workout-hero">
        <h1>WORKOUT PROGRAMS</h1>
        <p>Beginner-friendly. Science-backed. Results-driven.</p>
        <span className="red-line"></span>
      </section>



      {/* ---------------- TRAINING LEVELS ---------------- */}
      <section className="level-section">
        <h2 className="section-title">TRAINING LEVELS</h2>

        <div className="level-grid">

          <div
            className={`level-box ${level === "beginner" ? "active" : ""}`}
            onClick={() => setLevel("beginner")}
          >
            <h3>BEGINNER</h3>
            <p>1 body part per day • Focus on form</p>
          </div>

          <div
            className={`level-box mid ${level === "intermediate" ? "active" : ""}`}
            onClick={() => setLevel("intermediate")}
          >
            <h3>INTERMEDIATE</h3>
            <p>2 muscle groups per day • Balanced strength</p>
          </div>

          <div
            className={`level-box ${level === "advanced" ? "active" : ""}`}
            onClick={() => setLevel("advanced")}
          >
            <h3>ADVANCED</h3>
            <p>Push • Pull • Legs athletic protocol</p>
          </div>

        </div>
      </section>



      {/* ---------------- DYNAMIC CATEGORY GRID ---------------- */}
      <section className="w-category-section">
        <h2 className="section-title">
          {level === "beginner" && "BEGINNER WORKOUT SPLIT"}
          {level === "intermediate" && "INTERMEDIATE MUSCLE COMBINATIONS"}
          {level === "advanced" && "ADVANCED PUSH • PULL • LEGS"}
        </h2>

        <div className="w-grid">

          {categories[level].map((item, i) => (
            <div key={i} className={`w-card dynamic-card`}>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}

        </div>
      </section>

      {/* ---------------- BEGINNER EXERCISE TABLES ---------------- */}
      <section className="exercise-tables">
        <h2 className="section-title">BEGINNER EXERCISE GUIDE</h2>

        {/* PUSH DAY TABLE */}
        <div className="table-block">
          <h3>Push Day (Chest / Shoulders / Triceps)</h3>
          <table>
            <thead>
              <tr>
                <th>Exercise</th>
                <th>Muscle</th>
                <th>Sets</th>
                <th>Reps</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Push-Ups</td><td>Chest</td><td>3</td><td>10–12</td></tr>
              <tr><td>Dumbbell Shoulder Press</td><td>Shoulders</td><td>3</td><td>10</td></tr>
              <tr><td>Incline Dumbbell Press</td><td>Chest</td><td>3</td><td>10–12</td></tr>
              <tr><td>Tricep Dips (Bench)</td><td>Triceps</td><td>3</td><td>12–15</td></tr>
            </tbody>
          </table>
        </div>

        {/* PULL DAY TABLE */}
        <div className="table-block">
          <h3>Pull Day (Back / Biceps)</h3>
          <table>
            <thead>
              <tr>
                <th>Exercise</th>
                <th>Muscle</th>
                <th>Sets</th>
                <th>Reps</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Lat Pulldown</td><td>Back</td><td>3</td><td>10–12</td></tr>
              <tr><td>Seated Cable Row</td><td>Back</td><td>3</td><td>10–12</td></tr>
              <tr><td>Face Pulls</td><td>Rear Delts</td><td>3</td><td>12–15</td></tr>
              <tr><td>Dumbbell Curls</td><td>Biceps</td><td>3</td><td>10–12</td></tr>
            </tbody>
          </table>
        </div>

        {/* LEG DAY TABLE */}
        <div className="table-block">
          <h3>Leg Day (Quads / Hamstrings / Glutes)</h3>
          <table>
            <thead>
              <tr>
                <th>Exercise</th>
                <th>Muscle</th>
                <th>Sets</th>
                <th>Reps</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Bodyweight Squats</td><td>Quads</td><td>3</td><td>12–15</td></tr>
              <tr><td>Romanian Deadlift</td><td>Hamstrings</td><td>3</td><td>10–12</td></tr>
              <tr><td>Leg Press</td><td>Quads</td><td>3</td><td>10–12</td></tr>
              <tr><td>Glute Bridge</td><td>Glutes</td><td>3</td><td>12–15</td></tr>
            </tbody>
          </table>
        </div>

      </section>



      {/* ---------------- WEEKLY SPLIT ---------------- */}
      <section className="weekly-section">
        <h2 className="section-title">WEEKLY TRAINING SPLIT</h2>

        <div className="weekly-grid">

          <div className="day-box">
            <h4>MONDAY</h4>
            <span>Push Day</span>
            <p>Chest + Shoulders + Triceps</p>
          </div>

          <div className="day-box">
            <h4>TUESDAY</h4>
            <span>Pull Day</span>
            <p>Back + Rear Delts + Biceps</p>
          </div>

          <div className="day-box">
            <h4>WEDNESDAY</h4>
            <span>Leg Day</span>
            <p>Quads + Hams + Glutes</p>
          </div>

          <div className="day-box">
            <h4>THURSDAY</h4>
            <span>Core + Mobility</span>
            <p>Abs + Obliques + Stretch Flow</p>
          </div>

          <div className="day-box">
            <h4>FRIDAY</h4>
            <span>Full Body Strength</span>
            <p>Compounds + Conditioning</p>
          </div>

          <div className="day-box">
            <h4>SATURDAY</h4>
            <span>Conditioning</span>
            <p>HIIT + Sled Push + Assault Bike</p>
          </div>

          <div className="day-box rest">
            <h4>SUNDAY</h4>
            <span>Rest Day</span>
            <p>Mobility + Walk + Light Recovery</p>
          </div>
        </div>
      </section>



      {/* ---------------- FINAL CTA ---------------- */}
      <section className="workout-cta">
        <h1>TRANSFORM THROUGH TRAINING.</h1>
        <button>Start Your Fitness Journey</button>
      </section>

    </div>
  );
};

export default Workout;
